/** This file is used to export all the css features without IOC, in order to be consumed from @wix/thunder-state-manager */

import { landingPageCssFeature } from '../../features/landingPageCss/landingPageCssFeature'
import { responsiveLayoutCssFeature } from '../../features/responsiveLayout/responsiveLayoutCssFeature'
import { variablesCssFeature } from '../../features/variables/variablesCssFeature'
import { styleBasedFeature } from '../../features/styleBased/styleBasedFeature'
import { canvasCssFeature } from '../../features/canvas/canvasCssFeature'
import { motionCssFeature } from '../../features/motionCss/motionCssFeature'
import { motionEffectsCssFeature } from '../../features/motionEffects/motionEffectsCssFeature'
import { motionTimeAnimationsCssFeature } from '../../features/motionTimeAnimations/motionTimeAnimationsCssFeature'
import { transitionsCssFeature } from '../../features/transitions/transitionsCssFeature'
import { transformationsCssFeature } from '../../features/transformations/transformationsCssFeature'
import { accessibilityCssFeature } from '../../features/accessibilityStyle/accessibilityStyleCssFeature'
import { zIndexCssFeature } from '../../features/zIndexCss/zIndexCssFeature'
import { meshCssFeature } from '../../features/mesh/meshCssFeature'
import { fontFacesCssFeature } from '../../features/fontFaces/fontFacesFeature'
import { stylableCssFeature } from '../../features/stylable/stylableFeature'
import { pinnedLayoutCssFeature } from '../../features/pinnedLayout/pinnedLayoutCssFeature'
import { cursorCssFeature } from '../../features/cursor/cursorCssFeature'
import { themeFontsAndColorsCssFeature } from '../../features/themeFontsAndColors/themeFontsAndColorsCssFeature'
import { imageXScrollEffectsCssFeature } from '../../features/imageXScrollEffects/imageXScrollEffectsCssFeature'
import { screenInCssFeature } from '../../features/screenIn/screenInCssFeature'
import { presetsCssFeature } from '../../features/presets/presetsCssFeature'
import { compsMeasuresCssFeature } from '../../features/compsMeasures/compsMeasuresCssFeature'
import { svgBackgroundImageCssFeature } from '../../features/SVGBackgroundImage/SVGBackgroundImageCssFeature'
import { pageTransitionsCssFeature } from '../../features/pageTransitions/pageTransitionsCssFeature'
import type { CssFeature } from '../../features/cssFeature.types'

export const VSM_CSS_FEATURES: Record<string, CssFeature<any>> = {
	landingPages: landingPageCssFeature,
	responsiveLayout: responsiveLayoutCssFeature,
	variables: variablesCssFeature,
	styleBased: styleBasedFeature,
	screenIn: screenInCssFeature,
	canvas: canvasCssFeature,
	motion: motionCssFeature,
	motionEffects: motionEffectsCssFeature,
	motionTimeAnimations: motionTimeAnimationsCssFeature,
	transitions: transitionsCssFeature,
	transformations: transformationsCssFeature,
	accessibility: accessibilityCssFeature,
	compsMeasuresCss: compsMeasuresCssFeature, // Uses modes
	zIndexCss: zIndexCssFeature,
	mesh: meshCssFeature,
	fontFaces: fontFacesCssFeature,
	stylableCss: stylableCssFeature,
	pinnedLayout: pinnedLayoutCssFeature,
	presets: presetsCssFeature,
	cursor: cursorCssFeature,
	themeFontsAndColors: themeFontsAndColorsCssFeature,
	imageXScrollEffects: imageXScrollEffectsCssFeature,
	svgBackgroundImage: svgBackgroundImageCssFeature,
	pageTransitions: pageTransitionsCssFeature,
}

export const VSM_CSS_RESPONSIVE_MASTER_PAGE_FEATURES: Record<string, CssFeature<any>> = {
	accessibility: accessibilityCssFeature,
	fontFaces: fontFacesCssFeature,
	themeFontsAndColors: themeFontsAndColorsCssFeature,
	variables: variablesCssFeature,
}
